export default __webpack_public_path__ + "static/media/html_tutorial.02ac0900.pdf";